"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemList = void 0;
const react_1 = __importStar(require("react"));
function Item({ item, index, arr, save }) {
    const [val, setVal] = react_1.useState(item);
    return react_1.default.createElement("li", { key: index },
        react_1.default.createElement("input", { value: val, onChange: ev => setVal(ev.target.value), onBlur: () => {
                arr[index] = val;
                save(arr);
            } }),
        " ",
        react_1.default.createElement("span", { className: "button", onClick: () => {
                arr[index] = "";
                save(arr);
            } }, "x"));
}
function ItemList({ items, onChange, onNew, shuffle }) {
    const shuffleItems = () => {
        items.sort((a, b) => 0.5 - Math.random());
        onChange(items);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("ul", null, items.map((k, i, a) => react_1.default.createElement(Item, { key: `${i}-${k}`, item: k, index: i, arr: a, save: onChange }))),
        react_1.default.createElement("button", { onClick: onNew }, "Add"),
        shuffle ? react_1.default.createElement("button", { onClick: shuffleItems }, "Shuffle") : null));
}
exports.ItemList = ItemList;
